import axiosClient from '../../configs/axios';


class CustomerProductMasterService {
    // Get list 
    async getCpdList(params) {
        try {
            const response = await axiosClient.get(
                `/cpd/get?page=${params.page}&&size=${params.size}&&searchKey=${params.searchKey}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Add 
    async addCpd(data) {
        try {
            const response = await axiosClient.post('/cpd/add', data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }

    // Edit or delete
    async editDeleteCpd(data) {
        try {
            const response = await axiosClient.put(`/cpd/editDelete`, data);
            return response.data;
        } catch (error) {
            throw error;
        }
    }
}

export default new CustomerProductMasterService(); 